import img from "assets/images/content-block-thumbnails/form.png";
import { blockType } from "./constants";
import { strings } from "./strings";
import { BlockImages } from "../../__shared__/types";

// TODO: don't know if this one is needed?
export const FieldImages: BlockImages = {
  thumbnail: {
    name: strings.NAME,
    image: img,
    type: blockType,
  },
};
